// Italia
export default {
	status: {
		400: "Richiesta non riuscita! Riprova più tardi",
		401: "Sessione di accesso scaduta! Effettua nuovamente l'accesso",
		403: "L'account attuale non ha il permesso di accesso",
		404: "La risorsa a cui stai cercando di accedere non esiste",
		405: "Metodo di richiesta errato! Riprova più tardi",
		408: "Richiesta scaduta! Riprova più tardi",
		500: "Il servizio ha riscontrato un'eccezione",
		990: "Il vostro conto è stato bloccato per lungo tempo a causa di attività non completate",
		10030008: "Si prega di restituire il fondo di assistenza prima di richiedere il prelievo di contanti",
		10030010: "Il codice di invito non esiste",
		10030011: "Superato il numero massimo di volte di check-in",
		10030012: "Non soddisfa le condizioni di check-in, completa prima il compito",
		10030013: "Errore di configurazione del login, contatta l'assistenza clienti",
		10030014: "Non entro il periodo consentito",
		10030015: "Il membro non esiste",
		10030016:
			"Caro utente: Congratulazioni! Hai completato con successo il 100% della promozione del tuo prodotto. Contatta il supporto della piattaforma per richiedere un ripristino.",
		10030017: "Impossibile abbinare il prodotto, contatta l'assistenza clienti",
		10030018: "Saldo del conto insufficiente",
		10030019: "L'account è stato disabilitato",
		10030020: "Account vietato dalle negoziazioni",
		10030021: "Vietato il prelievo dell'account",
		10030022: "Errore nella password di transazione",
		10030023: "L'account di prelievo non è vincolato, vincola prima l'account di prelievo",
		10030024: "Errore nella vecchia password",
		10030027: "Il tuo prelievo è limitato. Contatta il servizio clienti per maggiori dettagli",
		10030028: "Punteggi di credito bassi impediscono di prelevare denaro",
		10030030: "Non entro il periodo consentito",
		10030031: "Contattare il servizio clienti per reimpostare l'attività di oggi",
		10030050: "L'ordine è scaduto. Si prega di contattare il servizio clienti per assistenza."
	},
	errorHandler: {
		InternalError: "Errore interno nel motore JavaScript",
		ReferenceError: "Oggetto non trovato",
		TypeError: "Tipo o oggetto errato utilizzato",
		RangeError: "Parametro fuori campo quando si utilizzano oggetti integrati",
		SyntaxError: "Errore di sintassi",
		EvalError: "Utilizzo errato di Eval",
		URIError: "Errore URI",
		UnknownError: "Sconosciuto"
	},
	Network: {
		timedout: "Richiesta scaduta! Riprova più tardi",
		error: "Errore di rete! Riprova più tardi"
	},
	request: {
		NoMoreData: "Nessun altro dato",
		OnlyImage: "Carica solo file immagine.",
		FileMaxSize: "La dimensione del file supera il valore massimo, che è {0}M"
	},
	response: {
		loading: "Caricamento",
		success: "Successo",
		fail: "Fallito",
		complete: "Completo"
	},
	page: {
		noVerify: "Portafoglio non verificato, si prega di verificare prima il portafoglio",
		notexist: "Spiacente, la pagina che stai cercando di raggiungere non esiste~"
	}
};
